import { render, staticRenderFns } from "./JeecgTreeTable.vue?vue&type=template&id=06a6f943&scoped=true&"
import script from "./JeecgTreeTable.vue?vue&type=script&lang=js&"
export * from "./JeecgTreeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a6f943",
  null
  
)

export default component.exports